/**
 * Mock localStorage on server side level
 * TODO: Have server side storage for session management
 */
class QoalaStorage {
    get isBrowser() {
        return typeof window !== 'undefined';
    }
    setItem(key, value) {
        if (this.isBrowser) {
            return localStorage.setItem(key, value);
        }
        return null;
    }
    removeItem(key) {
        if (this.isBrowser) {
            return localStorage.removeItem(key);
        }
        return null;
    }
    getItem(key) {
        if (this.isBrowser) {
            return localStorage.getItem(key);
        }
        return null;
    }
    clear() {
        if (this.isBrowser) {
            return localStorage.clear();
        }
    }
}
export default new QoalaStorage();
